export default "__VITE_ASSET__D$33P1Dz__"